import {
  PWA_UPDATE_RESCUE_ACK_MESSAGE_TYPE,
  PWA_UPDATE_RESCUE_PROBE_MESSAGE_TYPE,
  type PwaEnvironment
} from "./types";

const noCleanupNeeded = () => undefined;

export function createBrowserPwaEnvironment(): PwaEnvironment {
  return {
    isOnline: () => (typeof navigator === "undefined" ? true : navigator.onLine),
    reloadPage: () => {
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    },
    subscribeToConnectivity: (onOnline, onOffline) => {
      if (typeof window === "undefined") {
        return noCleanupNeeded;
      }

      window.addEventListener("online", onOnline);
      window.addEventListener("offline", onOffline);

      return () => {
        window.removeEventListener("online", onOnline);
        window.removeEventListener("offline", onOffline);
      };
    },
    subscribeToVisibility: (onVisible) => {
      if (typeof document === "undefined") {
        return noCleanupNeeded;
      }

      const handleVisibilityChange = () => {
        if (document.visibilityState === "visible") {
          onVisible();
        }
      };

      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () =>
        document.removeEventListener("visibilitychange", handleVisibilityChange);
    },
    subscribeToServiceWorkerMessages: (listener) => {
      if (typeof navigator === "undefined" || navigator.serviceWorker === undefined) {
        return noCleanupNeeded;
      }

      const serviceWorker = navigator.serviceWorker;
      const handleMessage = (event: MessageEvent<unknown>) => {
        if (
          typeof event.data === "object" &&
          event.data !== null &&
          Reflect.get(event.data, "type") ===
            PWA_UPDATE_RESCUE_PROBE_MESSAGE_TYPE
        ) {
          event.ports[0]?.postMessage({
            type: PWA_UPDATE_RESCUE_ACK_MESSAGE_TYPE
          });
        }

        listener(event.data);
      };

      serviceWorker.addEventListener("message", handleMessage);

      return () => serviceWorker.removeEventListener("message", handleMessage);
    }
  };
}
